export const BANK_OPTIONS = [
  { value: 'SCB', label: 'ธนาคารไทยพาณิชย์' },
  { value: 'BBL', label: 'ธนาคารกรุงเทพ' },
  { value: 'KTB', label: 'ธนาคารกรุงไทย' },
  { value: 'KBANK', label: 'ธนาคารกสิกรไทย' },
  { value: 'TMB', label: 'ธนาคารทหารไทย' },
  { value: 'BAY', label: 'ธนาคารกรุงศรีอยุธยา' },
  { value: 'GSB', label: 'ธนาคารออมสิน' },
  { value: 'BAAC', label: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร' },
  { value: 'TBANK', label: 'ธนาคารธนชาต' },
  { value: 'CIMBT', label: 'ธนาคารซีไอเอ็มบี ไทย' },
  { value: 'UOBT', label: 'ธนาคารยูโอบี' },
  { value: 'LH', label: 'ธนาคารแลนด์ แอนด์ เฮ้าส์' },
  { value: 'ICBCT', label: 'ธนาคารไอซีบีซี (ไทย)' },
  { value: 'TISCO', label: 'ธนาคารทิสโก้' },
  { value: 'KKP', label: 'ธนาคารเกียรตินาคินภัทร' },
]
